import cartActions from './cartActions';
import productsActions from './productsActions';

const allActions = {
  cartActions,
  productsActions,
};

export default allActions;
